import { NavLink } from "react-router-dom";

const sections = [
  { key: "story", label: "剧情介绍", to: "/category/story", icon: "ri-book-2-line", desc: "分集剧情与解读" },
  { key: "cast", label: "演员名单", to: "/category/cast", icon: "ri-user-star-line", desc: "主创与角色资料" },
  { key: "clip", label: "精彩片段", to: "/category/clip", icon: "ri-film-line", desc: "回顾 / 对白 / 花絮" },
  { key: "about", label: "关于本站", to: "/about", icon: "ri-information-line", desc: "定位与联系方式" },
];

export default function SideNav({ active }: { active?: string }) {
  return (
    <aside className="lg:w-60 lg:flex-shrink-0">
      <div className="lg:sticky lg:top-24 lg:rounded-lg lg:border lg:border-background-200/70 lg:bg-background-50 lg:p-3">
        <p className="hidden px-2 pb-2 text-xs text-foreground-400 lg:block">栏目导航</p>
        <ul className="no-scrollbar flex gap-2 overflow-x-auto lg:flex-col lg:gap-1 lg:overflow-visible">
          {sections.map((section) => (
            <li key={section.key} className="flex-shrink-0 lg:w-full">
              <NavLink
                to={section.to}
                className={({ isActive }) =>
                  `flex items-center gap-3 whitespace-nowrap rounded-md px-3 py-2.5 text-sm transition ${
                    isActive || active === section.key
                      ? "bg-primary-50 text-primary-700"
                      : "text-foreground-600 hover:bg-background-100"
                  }`
                }
              >
                <span className="flex h-8 w-8 items-center justify-center rounded-md bg-background-100 text-base">
                  <i className={section.icon}></i>
                </span>
                <span className="leading-tight">
                  <span className="block">{section.label}</span>
                  <span className="hidden text-[11px] text-foreground-400 lg:block">{section.desc}</span>
                </span>
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </aside>
  );
}